<div *ngIf="snapshot | async as snap">

  <div *ngIf="downloadURL">
    <img [src]="downloadURL" class="result-image"/><br>
  </div>
</div>